import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AppStateFeature } from 'src/app/store/app-state-feature.enum';

import { SimsearchState } from './simsearch.state';

const selectSimsearchState = createFeatureSelector<SimsearchState>(AppStateFeature.Simsearch);

export const selectSimsearchVehicleId = createSelector(selectSimsearchState, state => state?.vehicleId);

export const selectSimsearchCurrentVehicle = createSelector(selectSimsearchState, state => state?.vehicleConfiguration);

export const selectSimsearchSimilarVehicles = createSelector(selectSimsearchState, state => state?.similarVehicles);

export const selectSimsearchFootnotes = createSelector(selectSimsearchState, state => state?.footnotes);
